import { connect } from 'react-redux'
import { withHandlers, compose } from 'recompose'
import CheckboxList from 'components/common/FormElements/CheckboxList/CheckboxList'
import { showProvidedNumberPhoneModal } from '../../ProvidePhoneNumberModal/actions'
import { getProvidePhoneNumberFormValues } from '../selectors'
import { CALL_ME_PREFERENCE } from '../constants'

const withControlHandlers = withHandlers({
  handleChange: ({
    onChange,
    value,
    placeholder,
    accountContactDetails: { primaryPhone, alternatePhone },
    showProvidedNumberPhoneModal,
    phoneNumberFormValues
  }) =>
    (checkboxValue, checked) => {
      const newValue =
        checked ?
          [...value, checkboxValue].filter(value => value !== placeholder) :
          value.filter(value => value !== checkboxValue)

      onChange(newValue)

      if (newValue.includes(CALL_ME_PREFERENCE) && !primaryPhone && !alternatePhone) {
        showProvidedNumberPhoneModal(phoneNumberFormValues, newValue)
      }
    },
  handleReset: ({ onChange }) => () => onChange([])
})

export default compose(
  connect(
    state => ({
      phoneNumberFormValues: getProvidePhoneNumberFormValues(state)
    }), { showProvidedNumberPhoneModal }),
  withControlHandlers
)(CheckboxList)
